<template>
    <div>
        <div class="table-container">
            <table class="minimalist-table">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Cantidad</th>
                        <th>Precio Unitario</th>
                        <th>Descuento Total</th>
                        <th>Subtotal</th>
                        <th>IVA</th>
                        <th>Total</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredItems.data" :key="item.id">
                        <td>
                            <strong>{{ item.item.name }}</strong>
                            <p class="description">{{ item.item.description }}</p>
                        </td>
                        <td class="center-text">{{ item.quantity }}</td>
                        <td class="center-text">${{ item.item.price }}</td>
                        <td class="center-text">${{ item.discount }}</td>
                        <td class="center-text">${{ item.subtotal }}</td>
                        <td class="center-text">${{ item.tax }}</td>
                        <td class="center-text" :class="{ 'refund-row': item.is_refund === true }">${{ item.total }}
                        </td>
                        <td class="center-text">
                            <button class="btn btn-link p-0 px-2 pt-2" @click.prevent="handleRefund(item)">
                                <i class="fa-solid fa-eraser"></i>
                            </button>
                            <button class="btn btn-link p-0 px-2 pt-2" @click.prevent="openEditModal(item)">
                                <i class="fa-duotone fa-solid fa-pen-to-square"></i>
                            </button>
                            <button
class="btn btn-link p-0 px-1 pt-2"
                                @click.prevent="Delete(item, item.item.name, 'del carrito')">
                                <i class="fa-duotone fa-solid fa-trash"></i>
                            </button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <Pagination
class="mt-3" :total-items="totalItems" :current-page="currentPage" :last-page="lastPage"
            :items-per-page="itemsPerPage" @page-change="changePage" />
        <Modal v-if="openModal" v-model="openModal" :is-edit-mode="isEditMode" @submit-entity="handleEntity">
            <template #default>
                <div class="mb-3">
                    <label for="quantity" class="form-label">Cantidad</label>
                    <Quantity v-model="localQuantity" />
                </div>
                <div class="mb-3">
                    <label for="comment" class="form-label">Comentario</label>
                    <input id="comment" v-model="localComment" type="text" class="form-control" />
                </div>
            </template>
        </Modal>
        <div v-if="hasRefunds" class="refund-notice">
            <i class="fa-solid fa-circle p-0 px-1 refund-notice-color"></i><span> Items reembolsados</span>
        </div>

    </div>
</template>

<script setup>
import {
    ref,
    getCurrentInstance,
    defineEmits,
    watch,
    onMounted,
    defineProps,
    computed
} from "vue";
import Pagination from "@/components/Pagination.vue";
import { useActions } from "@/composables/useActions";
import Modal from "@/components/Modal.vue";
import Quantity from "@/components/Quantity.vue";
import Swal from "sweetalert2";
import api from "@/services/api";

const { proxy } = getCurrentInstance();
const resourceApi = "sale-details";

const emit = defineEmits(["get-entity"]);

const {
    currentPage,
    itemsPerPage,
    lastPage,
    filteredItems,
    totalItems,
    changePage,
    fetchItems,
    updateShowDeleted,
    addModel,
    editModel,
    getRecord,
    showRecord,
    confirmDelete,
    setAdditionalParams,
    message,
} = useActions(resourceApi);

const openModal = ref(false);
const isEditMode = ref(true);
const selectedItem = ref(null);
const localQuantity = ref(1);
const localComment = ref("");

const openEditModal = (item) => {
    selectedItem.value = { ...item };
    localQuantity.value = item.quantity;
    localComment.value = item.comment;
    openModal.value = true;
};

const hasRefunds = computed(() => {
    return (
        filteredItems.value?.data && // Verifica que 'filteredItems.value' y 'data' existen
        Array.isArray(filteredItems.value.data) && // Confirma que 'data' es un array
        filteredItems.value.data.some(item => item.is_refund === true) // Aplica '.some()' solo si es un array
    );
});


watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

onMounted(async () => {
    await fetchItems();
    updateShowDeleted(false);
    setAdditionalParams({ sale_id: props.data.id });
    getSale();
});

const props = defineProps({
    data: Object,
    formData: Object,
});

const getSale = async () => {
    const getSale = await showRecord(props.data, "sales");
    emit("get-entity", getSale);
};

const Delete = async (item, name, entity) => {
    await confirmDelete(item, name, entity);
    fetchItems();
    getSale();
};

const handleEntity = async () => {
    let response;
    response = await editModel({
        id: selectedItem.value.id,
        quantity: localQuantity.value,
        comment: localComment.value,
    });
    if (response && (response.status === 200 || response.status === 201)) {
        fetchItems();
        getSale();
        proxy.$notify(message.value, "", "success", "ni ni-like-2 ni-lg");
    }
    openModal.value = false;
};

const handleRefund = async (item) => {
    const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Se regresarán los productos al inventario y se aplicará un rembolso al cliente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, aplicar rembolso",
        cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
        try {
            const response = await api.post(`/sale-details/${item.id}/refund`);
            if (response.status === 200) {
                Swal.fire({
                    title: "Rembolso aplicado",
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "Cerrar",
                });
                await fetchItems(currentPage.value, true);
                getSale();
                proxy.$eventBus.emit('refundApplied');
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text:
                    error.response && error.response.status === 422
                        ? error.response.data.error
                        : "Ocurrió un error al aplicar el rembolso.",
                icon: "error",
                confirmButtonText: "Cerrar",
            });
        }
    } else {
        console.log("Rembolso cancelado");
    }
};

watch(
    () => props.formData,
    async (newItem) => {
        const item = await getRecord("items");
        if (newItem) {
            let response;
            const saleData = {
                sale_id: props.data.id,
                item_id: item.id,
                quantity: newItem.quantity,
                comment: newItem.description,
            };
            response = await addModel(saleData);
            if (response && (response.status === 200 || response.status === 201)) {
                proxy.$notify(message.value, "", "success", "ni ni-like-2 ni-lg");
                getSale();
            }
        }
    }
);
</script>

<style scoped>
/* Contenedor de la tabla */
.table-container {
    margin-top: 1rem;
    overflow-x: auto;
}

/* Estilo general de la tabla */
.minimalist-table {
    width: 100%;
    border-collapse: collapse;
    font-family: "Inter", sans-serif;
    font-size: 0.9rem;
}

/* Encabezados de la tabla */
.minimalist-table th {
    background-color: #f8f9fa;
    color: #6c757d;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    padding: 12px;
    text-align: center;
}

/* Filas y celdas */
.minimalist-table td {
    padding: 14px 10px;
    border-bottom: 1px solid #e0e0e0;
    vertical-align: middle;
    /* Asegura alineación vertical correcta */
}

/* Asegurar que la primera columna (Nombre) esté alineada a la izquierda */
.minimalist-table td:first-child {
    text-align: left;
    padding-left: 16px;
}

/* Alternar colores en filas */
.minimalist-table tr:nth-child(even) {
    background-color: #fdfdfd;
}

.minimalist-table tr:hover {
    background-color: #f4f6f8;
}

/* Centrar el texto en las columnas de cantidad, descuento, IVA y total */
.center-text {
    text-align: center;
    font-weight: bold;
    color: #343a40;
}

/* Descripción del producto */
.description {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 4px;
}

/* Asegurar que la celda de acciones ocupe la altura total de la fila */
.minimalist-table td:last-child {
    height: 100%;
    vertical-align: middle;
    /* Evita que el contenido se desplace hacia arriba */
    padding: 0;
    /* Elimina padding extra */
}

/* Estilos de los botones */
.btn-group button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    /* Elimina cualquier padding extra */
    margin: 0;
    /* Elimina cualquier margen extra */
    height: 100%;
    /* Asegura que el botón ocupe toda la celda */
}

/* Estilos de los iconos */
.btn-group i {
    font-size: 1.2rem;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

/* Hover en los iconos */
.icon-edit:hover {
    color: #007bff;
    transform: scale(1.1);
}

.icon-delete:hover {
    color: #dc3545;
    transform: scale(1.1);
}

/* Evitar que el borde inferior de la fila se corte */
.minimalist-table tr:last-child td {
    border-bottom: none;
}

.refund-row {
    background-color: #ffcccc;
    border-radius: 4px;
}

.refund-notice-color {
    color: #ffcccc;
}

.refund-notice {
    padding-top: 0px;
    border-radius: 5px;
    text-align: left;
    color: #333;
    display: flex;
    align-items: center;
    height: 40px;
    font-size: .80rem;
}
</style>
